import styled from 'styled-components';
import { SummaryDiscountDetailsStyled } from '../SummaryDiscountDetailsStyled';
import { rem } from 'polished';

export const SummaryDiscountDetailsAC = styled(SummaryDiscountDetailsStyled)`
    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h2};
            color: ${({ theme }) => theme.colors.grey5};
        }
        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.red};
                }
            }
        }
        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.red};
                }
            }
        }
    }

    .section {
        .discounts {
            .discount,
            .totalPrice {
                font-size: ${({ theme }) => theme.fontSizes.h4};
            }
        }
    }
`;
